// const Countdown = () => {
//   const now = new Date();
//   const countDate = new Date("August 31 2026 23:59:59 GMT-0400").getTime();
//   const gap = countDate - now;

//   const second = 1000;
//   const minute = second * 60;
//   const hour = minute * 60;
//   const day = hour * 24;

//   const textDay = Math.floor(gap / day);
//   const textHour = Math.floor((gap % day) / hour);
//   const textMinute = Math.floor((gap % hour) / minute);
//   const textSecond = Math.floor((gap % minute) / second);
//   const textMillisecond = (gap % 1000) / 1000;
//   const msString = String(Math.floor(textMillisecond * 100)).padStart(2, "0"); // Truncate to 2 digits

//   const pad = (num, digits = 2) => String(num).padStart(digits, "0");

//   if (gap >= 0){
//     document.querySelector('.day').innerText = pad(textDay);
//     document.querySelector('.hour').innerText = pad(textHour);
//     document.querySelector('.minute').innerText = pad(textMinute);

//     const dayContainer = document.querySelector('.container-day');
//     const secondEl = document.querySelector('.second');
//       // Add seconds + millisecond span
//       secondEl.innerHTML = `${pad(textSecond)}<span class="ms">.${msString}</span>`;
//   }
// };

// setInterval(Countdown, 25);


(function () {
    function initializeLgndCountdown() {
      var root = document.getElementById("lgnd-fixed-countdown");

      if (!root || root.dataset.countdownInitialized === "true") return;

      var endSeconds = Number(root.getAttribute("data-countdown-end"));
      var timer = root.querySelector(".lgnd-countdown__timer");
      var expiredMessage = root.querySelector("[data-countdown-expired]");

      if (!endSeconds || !timer) return;

      var endTime = endSeconds * 1000;
      var reducedMotion =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      var units = {
        days: root.querySelector('[data-countdown-unit="days"]'),
        hours: root.querySelector('[data-countdown-unit="hours"]'),
        minutes: root.querySelector('[data-countdown-unit="minutes"]'),
        seconds: root.querySelector('[data-countdown-unit="seconds"]')
      };

      if (!units.days || !units.hours || !units.minutes || !units.seconds) {
        return;
      }

      root.dataset.countdownInitialized = "true";

      function pad(number) {
        return String(Math.max(0, number)).padStart(2, "0");
      }

      function setUnit(unit, nextValue, animate) {
        var card = unit.querySelector(".lgnd-flip-card");
        var staticTop = unit.querySelector("[data-countdown-static-top]");
        var staticBottom = unit.querySelector("[data-countdown-static-bottom]");
        var flipTop = unit.querySelector("[data-countdown-flip-top]");
        var flipBottom = unit.querySelector("[data-countdown-flip-bottom]");

        if (
          !card ||
          !staticTop ||
          !staticBottom ||
          !flipTop ||
          !flipBottom
        ) {
          return;
        }

        var currentValue = unit.dataset.currentValue;

        if (currentValue === nextValue) return;

        if (!currentValue || !animate || reducedMotion) {
          staticTop.textContent = nextValue;
          staticBottom.textContent = nextValue;
          flipTop.textContent = nextValue;
          flipBottom.textContent = nextValue;
          unit.dataset.currentValue = nextValue;
          return;
        }

        card.classList.remove("is-flipping");
        void card.offsetWidth;

        flipTop.textContent = currentValue;
        flipBottom.textContent = nextValue;
        staticTop.textContent = nextValue;

        card.classList.add("is-flipping");

        window.setTimeout(function () {
          staticBottom.textContent = nextValue;
        }, 320);

        window.setTimeout(function () {
          card.classList.remove("is-flipping");
          flipTop.textContent = nextValue;
          flipBottom.textContent = nextValue;
        }, 680);

        unit.dataset.currentValue = nextValue;
      }

      function updateCountdown(animate) {
        var gap = Math.max(0, endTime - Date.now());

        var second = 1000;
        var minute = second * 60;
        var hour = minute * 60;
        var day = hour * 24;

        var values = {
          days: pad(Math.floor(gap / day)),
          hours: pad(Math.floor((gap % day) / hour)),
          minutes: pad(Math.floor((gap % hour) / minute)),
          seconds: pad(Math.floor((gap % minute) / second))
        };

        setUnit(units.days, values.days, animate);
        setUnit(units.hours, values.hours, animate);
        setUnit(units.minutes, values.minutes, animate);
        setUnit(units.seconds, values.seconds, animate);

        if (gap <= 0) {
          window.clearInterval(interval);

          if (expiredMessage) {
            expiredMessage.hidden = false;
          }
        }
      }

      var interval = null;

      /*
       * Liquid supplies the initial countdown values in the HTML.
       * JavaScript begins updating after the section has loaded.
       */
      updateCountdown(false);
      interval = window.setInterval(function () {
        updateCountdown(true);
      }, 1000);
    }

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        initializeLgndCountdown,
        { once: true }
      );
    } else {
      initializeLgndCountdown();
    }

    /*
     * GemPages can inject custom-code sections after DOMContentLoaded.
     * This provides one additional safe initialization attempt.
     */
    window.setTimeout(initializeLgndCountdown, 500);
  })();









  

var progress = document.querySelector('.progress');

let progressBar = document.getElementById("progressBAR");

  // Update the count down every 1 second
  var x = setInterval(function() {
    
  var begin = new Date("September 29, 2026 00:00:00").getTime();
  var end = new Date("October 15, 2026 23:59:59").getTime();

  // Get today's date and time
  var now = new Date();
  var localTime = now.getTime();
  var localOffset = now.getTimezoneOffset() * 60000;
  
  var utc = localTime + localOffset;
  // var offset = -5;   
  var offset = -4;
  var newyork = utc + (3600000*offset);

  var nowNewYork = new Date(newyork); 
    
  // nowActual is relative to beginning date of giveaway
  var nowActual = nowNewYork.getTime() - begin;

  // Find the distance between now and the count down date
  var distance = end - nowNewYork;
    
  // FULL DURATION NARROWS TIME FROM END TO BEGINNING
  var fullDuration = end - begin;
  // GET FRACTION OF ACTUAL CURRENT TIME DIVIDED BY FULL DURATION
  var timeLeft = nowActual/fullDuration;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // USE TO CHECK Dates in Number Formats
  // console.log(end2);
  // console.log(fullDuration2);
  // console.log(timeLeft2);
    
  // If time is UP or NOT BEGUN set progress bar to full, else fill it appropriately!
  if (timeLeft >= 1){
      progress.style.width = (100 + '%');
      progress.style.opacity = 1;
  } else if (timeLeft <= 0) {
    progress.style.width = (100 + '%');
    progress.style.opacity = 1;
  } else { 
      if ((timeLeft*100) > 60){
        progressBar.style.display = 'block';
         progress.style.width = (60 + (timeLeft*40) + '%');
        progress.style.opacity = 1;
      }
  }
 
}, 1000);



// const scriptURL = 'https://script.google.com/macros/s/AKfycbz2BOcsifI7fdB-yWPgA3riBOBwigQyDsFaQ7wxjQncBmkS04oA8gBStVi2FlSSrGtS_g/exec'

//   const form = document.forms['hc-form'];
//   const popUpContainer = document.getElementById("popUpMobile");
//   const initial = document.getElementById("initial-form");
//   const after = document.getElementById("after-form");
  
//   // Function to handle the form submission
//     function submitForm() {
//         fetch(scriptURL, { method: 'POST', body: new FormData(form) })
//             .then(response => console.log('Success!', response))
//             .catch(error => console.error('Error!', error.message));
//     }
    
//     // function handleSubmit(){
//     //   // initial.classList.toggle("hide");
//     //   //       after.classList.toggle("hide");
//     //         // console.log("SHOULD HIDE NOW!!");
//     //         submitForm(); // Submit form via fetch
//     // }
    
    

// document.addEventListener('DOMContentLoaded', function () {

//     // Add change event listeners to radio buttons
//     const radioButtons = form.querySelectorAll('input[type="radio"]');
//     radioButtons.forEach(radio => {
//         radio.addEventListener('change', function (e) {
//           initial.style.display = "none";
//             after.classList.toggle("hide");
//             console.log("Form button clicked, hiding buttons")
//           submitForm();
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
  const form = document.forms['hc-form'];
  const initial = document.getElementById("initial-form");
  const after = document.getElementById("after-form");

  let hasSubmitted = false;

  function submitForm() {
    if (hasSubmitted) return;

    hasSubmitted = true;

    fetch(scriptURL, {
      method: 'POST',
      body: new FormData(form)
    })
      .then(response => console.log('Success!', response))
      .catch(error => {
        console.error('Error!', error.message);
        hasSubmitted = false; // allow retry if it fails
      });
  }

  const radioButtons = form.querySelectorAll('input[type="radio"]');

  radioButtons.forEach(radio => {
    radio.addEventListener('change', function () {
      if (hasSubmitted) return;

      initial.style.display = "none";
      after.classList.remove("hide");

      console.log("Form button clicked, hiding buttons");

      submitForm();
    });
  });
});


/* LGND offer switcher V4.
 * REPLACE the previous switcher code.
 * Do not add <script> tags or Liquid to your JavaScript asset.
 */
(() => {
  'use strict';

  if (customElements.get('lgnd-offer-switcher')) return;

  const MEMBER_SWITCH_DELAY = 2000;
  const FAST_PASS_RESET_DELAY = 1500;
  let instanceCount = 0;

  class LGNDOfferSwitcher extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.selected = this.dataset.selected || 'fast';
        this.busy = false;
        this.animating = false;
        this.animationRevision = 0;
        this.cardAnimations = [];
        this.memberInCart = false;
        this.membershipChecking = true;
        this.fastAdded = false;
        this.cartRevision = 0;

        this.tabs = [...this.querySelectorAll('[data-select]')];
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.forms = [...this.querySelectorAll('[data-offer-form]')];
        this.status = this.querySelector('[data-status]');
        this.cartLink = this.querySelector('[data-cart-link]');

        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 1024px)');

        this.desktop.addEventListener(
          'change',
          () => this.handleLayoutChange(),
          options
        );

        this.memberForm = this.querySelector(
          '[data-panel="plus"] [data-offer-form]'
        );

        this.memberVariantId =
          this.memberForm.querySelector('[name="id"]').value;

        const prefix = `lgnd-offer-${++instanceCount}`;

        this.tabs.forEach(tab => {
          const panel = this.panels.find(
            item => item.dataset.panel === tab.dataset.select
          );

          tab.id = `${prefix}-${tab.dataset.select}-button`;
          panel.id = `${prefix}-${tab.dataset.select}-panel`;

          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'region');

          const heading = panel.querySelector('.lgnd-offers__offer-name');

          if (heading) {
            heading.id = `${prefix}-${tab.dataset.select}-heading`;
          }

          tab.addEventListener(
            'click',
            () => this.select(tab.dataset.select),
            options
          );
        });

        this.cards.forEach(card => {
          card.addEventListener(
            'click',
            () => this.select(card.dataset.card),
            options
          );
        });

        this.forms.forEach(form => {
          const label = form.querySelector('[data-button-label]');

          if (!label.dataset.idle) {
            label.dataset.idle = label.textContent;
          }

          form.addEventListener('submit', event => {
            event.preventDefault();
            this.addToCart(form);
          }, options);
        });

        this.setBusy(false);
        this.renderSelection();

        // Synchronize membership status with cart changes and removals.
        const onCartUpdate = event => {
          if (Array.isArray(event.detail?.cart?.items)) {
            this.updateFromCart(event.detail.cart);
          } else {
            this.queueCartRead();
          }
        };

        ['cart:change', 'variant:add', 'line-item:change'].forEach(name => {
          document.addEventListener(name, onCartUpdate, options);
        });

        ['cart:refresh', 'cart-drawer:refreshed'].forEach(name => {
          document.addEventListener(
            name,
            () => this.queueCartRead(),
            options
          );
        });

        window.addEventListener(
          'pageshow',
          () => this.queueCartRead(),
          options
        );

        this.readCart();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;

      clearTimeout(this.memberSwitchTimer);
      clearTimeout(this.fastResetTimer);
      clearTimeout(this.cartReadTimer);

      this.cartRevision++;
      this.cancelCardAnimations();

      this.getAnimations({ subtree: true }).forEach(animation => {
        animation.cancel();
      });

      // An in-flight cart add is not aborted: it may already have succeeded.
    }

    cancelCardAnimations() {
      this.animationRevision++;

      this.cardAnimations?.forEach(animation => animation.cancel());

      this.cardAnimations = [];
      this.animating = false;
      this.queued = null;
    }

    handleLayoutChange() {
      const focused = document.activeElement;

      const focusedPanel = this.panels.find(panel => {
        return panel.contains(focused);
      });

      const focusedSelector = [...this.tabs, ...this.cards].find(item => {
        return item === focused;
      });

      this.cancelCardAnimations();

      if (this.desktop.matches) {
        clearTimeout(this.memberSwitchTimer);
      } else {
        // Keep the focused/in-flight purchase visible when the screen narrows.
        const activePanel = this.activeForm?.closest('[data-panel]');

        this.selected =
          (focusedPanel || activePanel)?.dataset.panel || this.selected;
      }

      this.renderSelection();

      if (this.desktop.matches && focusedSelector) {
        const key =
          focusedSelector.dataset.select || focusedSelector.dataset.card;

        this.panels
          .find(panel => panel.dataset.panel === key)
          ?.querySelector('.lgnd-offers__offer-name')
          ?.focus({ preventScroll: true });
      }
    }

    renderSelection() {
      this.dataset.selected = this.selected;

      this.tabs.forEach(tab => {
        tab.setAttribute(
          'aria-pressed',
          String(tab.dataset.select === this.selected)
        );
      });

      this.cards.forEach(card => {
        const active = card.dataset.card === this.selected;

        card.dataset.front = String(active);
        card.setAttribute('aria-pressed', String(active));
      });

      this.panels.forEach(panel => {
        // Desktop exposes both offers; mobile exposes the selected offer.
        const active =
          this.desktop.matches || panel.dataset.panel === this.selected;

        panel.inert = !active;
        panel.setAttribute('aria-hidden', String(!active));

        const heading = panel.querySelector('.lgnd-offers__offer-name');

        const tab = this.tabs.find(item => {
          return item.dataset.select === panel.dataset.panel;
        });

        panel.setAttribute(
          'aria-labelledby',
          this.desktop.matches && heading ? heading.id : tab.id
        );
      });
    }

    async select(next, automatic = false) {
      if (!automatic) clearTimeout(this.memberSwitchTimer);

      if (
        this.desktop.matches ||
        this.busy ||
        !['fast', 'plus'].includes(next)
      ) return;

      if (this.animating) {
        this.queued = next;
        return;
      }

      if (next === this.selected) return;

      this.message('');

      const outgoing = this.cards.find(card => {
        return card.dataset.card === this.selected;
      });

      const incoming = this.cards.find(card => {
        return card.dataset.card === next;
      });

      const oldFront = getComputedStyle(outgoing).transform;
      const oldBack = getComputedStyle(incoming).transform;

      const distance =
        this.getBoundingClientRect().right -
        outgoing.getBoundingClientRect().left +
        outgoing.offsetWidth;

      const outside =
        `translate(${distance}px, -50%) rotate(15deg) scale(.94)`;

      this.animating = true;

      const animations = [];
      this.cardAnimations = animations;
      const revision = ++this.animationRevision;

      try {
        this.selected = next;
        this.dataset.selected = next;

        this.tabs.forEach(tab => {
          tab.setAttribute(
            'aria-pressed',
            String(tab.dataset.select === next)
          );
        });

        this.panels.forEach(panel => {
          panel.inert = panel.dataset.panel !== next;

          panel.setAttribute(
            'aria-hidden',
            String(panel.dataset.panel !== next)
          );
        });

        if (this.motion.matches || !outgoing.animate) {
          this.renderSelection();
          return;
        }

        const out = outgoing.animate(
          [{ transform: oldFront }, { transform: outside }],
          {
            duration: 250,
            easing: 'cubic-bezier(.5,0,.8,.5)',
            fill: 'forwards'
          }
        );

        animations.push(out);
        await out.finished;

        if (revision !== this.animationRevision) return;

        this.renderSelection();
        out.cancel();

        const rear = getComputedStyle(outgoing).transform;
        const front = getComputedStyle(incoming).transform;

        const backIn = outgoing.animate(
          [{ transform: outside }, { transform: rear }],
          {
            duration: 350,
            easing: 'cubic-bezier(.2,.8,.2,1)'
          }
        );

        const forward = incoming.animate(
          [
            { transform: oldBack, filter: 'brightness(.65)' },
            { transform: front, filter: 'brightness(1)' }
          ],
          {
            duration: 350,
            easing: 'cubic-bezier(.2,.8,.2,1)'
          }
        );

        animations.push(backIn, forward);
        await Promise.all([backIn.finished, forward.finished]);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('LGND card animation:', error);
        }
      } finally {
        animations.forEach(animation => animation.cancel());

        if (revision === this.animationRevision) {
          this.cardAnimations = [];
          this.renderSelection();
          this.animating = false;

          const queued = this.queued;
          this.queued = null;

          if (queued && this.isConnected) this.select(queued);
        }
      }
    }

    setBusy(busy, activeForm) {
      this.busy = busy;
      this.activeForm = busy ? activeForm : null;

      this.tabs.forEach(tab => {
        tab.disabled = busy;
      });

      this.cards.forEach(card => {
        card.disabled = busy;
      });

      this.updateButtons();
    }

    updateButtons() {
      this.forms.forEach(form => {
        const button = form.querySelector('[type="submit"]');
        const label = button.querySelector('[data-button-label]');

        const membership = form === this.memberForm;
        const loading = this.busy && form === this.activeForm;
        const added = membership ? this.memberInCart : this.fastAdded;

        const text = loading
          ? 'Adding'
          : added
            ? 'Added to Cart'
            : label.dataset.idle;

        button.disabled =
          this.busy ||
          added ||
          form.dataset.canBuy !== 'true' ||
          (membership && this.membershipChecking);

        button.setAttribute('aria-busy', String(loading));
        button.style.opacity = added && !loading ? '1' : '';

        const arrow = button.lastElementChild;

        if (arrow !== label) {
          arrow.hidden = loading || added;
        }

        const state = `${loading}:${text}`;

        if (label.dataset.state === state) return;

        label.dataset.state = state;
        label.spinnerAnimation?.cancel();
        label.textContent = '';

        if (loading) {
          const spinner = document.createElement('span');

          spinner.setAttribute('aria-hidden', 'true');
          spinner.dataset.offerSpinner = '';

          spinner.style.cssText =
            'display:inline-block;width:14px;height:14px;' +
            'margin-right:9px;vertical-align:-2px;' +
            'border:2px solid currentColor;' +
            'border-right-color:transparent;border-radius:50%;';

          label.append(spinner);

          if (!this.motion.matches) {
            label.spinnerAnimation = spinner.animate(
              [
                { transform: 'rotate(0deg)' },
                { transform: 'rotate(360deg)' }
              ],
              {
                duration: 650,
                iterations: Infinity,
                easing: 'linear'
              }
            );
          }
        }

        label.append(document.createTextNode(text));
      });
    }

    get cartRoot() {
      return (
        window.Shopify?.routes?.root ||
        this.dataset.root ||
        '/'
      ).replace(/\/?$/, '/');
    }

    updateFromCart(cart) {
      if (!Array.isArray(cart?.items)) return;

      this.cartRevision++;
      this.membershipChecking = false;

      this.memberInCart = cart.items.some(item => {
        return (
          String(item.variant_id ?? item.id) === this.memberVariantId &&
          Number(item.quantity ?? 1) > 0
        );
      });

      if (!this.memberInCart) {
        clearTimeout(this.memberSwitchTimer);
      }

      this.updateButtons();
    }

    queueCartRead() {
      clearTimeout(this.cartReadTimer);
      this.cartReadTimer = setTimeout(() => this.readCart(), 100);
    }

    async readCart() {
      const revision = ++this.cartRevision;

      try {
        const response = await this.request(
          `${this.cartRoot}cart.js`,
          { cache: 'no-store' }
        );

        if (!response.ok) throw new Error('Cart lookup failed.');

        const cart = await response.json();

        if (this.isConnected && revision === this.cartRevision) {
          this.updateFromCart(cart);
        }
      } catch (error) {
        // Preserve the last known state if the lookup is unavailable.
      } finally {
        if (this.isConnected && revision === this.cartRevision) {
          this.membershipChecking = false;
          this.updateButtons();
        }
      }
    }

    showAddedState(form) {
      if (form === this.memberForm) {
        clearTimeout(this.memberSwitchTimer);

        // Auto-switch only when using the mobile toggle layout.
        if (this.memberInCart && !this.desktop.matches) {
          this.memberSwitchTimer = setTimeout(() => {
            if (
              this.isConnected &&
              !this.desktop.matches &&
              this.memberInCart &&
              this.selected === 'plus'
            ) {
              this.select('fast', true);
            }
          }, MEMBER_SWITCH_DELAY);
        }
      } else {
        this.fastAdded = true;
        clearTimeout(this.fastResetTimer);

        this.fastResetTimer = setTimeout(() => {
          this.fastAdded = false;

          if (this.isConnected) this.updateButtons();
        }, FAST_PASS_RESET_DELAY);
      }
    }

    message(text, error = false, showCart = false) {
      this.status.textContent = text;
      this.dataset.error = String(error);
      this.cartLink.hidden = !showCart;
    }

    async request(url, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);

      try {
        return await fetch(url, {
          ...options,
          signal: controller.signal
        });
      } finally {
        clearTimeout(timer);
      }
    }

    


    // Apply Offer Discount


    getCartDiscountCodes(cart, appliedOnly = false) {
  const codes = (cart.discount_codes || [])
    .filter(item => !appliedOnly || item.applicable === true)
    .map(item => typeof item === 'string' ? item : item.code);

  const applications = [
    ...(cart.cart_level_discount_applications || []),
    ...(cart.items || []).flatMap(item =>
      [
        ...(item.line_level_discount_allocations || []),
        ...(item.discount_allocations || [])
      ].map(allocation => allocation.discount_application)
    )
  ];

  applications.forEach(application => {
    if (application?.type === 'discount_code') {
      codes.push(application.title);
    }
  });

  return [...new Map(
    codes
      .filter(code => typeof code === 'string' && code.trim())
      .map(code => [code.trim().toLowerCase(), code.trim()])
  ).values()];
}

async applyOfferDiscount(form, cart, sections) {
  const code = (form.dataset.discountCode || '').trim();

  // No setting in the HTML: skip the discount update entirely.
  if (!code) {
    return { cart, sections: null, notice: '' };
  }

  // Include existing codes rather than replacing them with only the promo.
  const codes = new Map(
    [...this.getCartDiscountCodes(cart), code].map(value =>
      [value.toLowerCase(), value]
    )
  );

  let updated = cart;
  let notice = '';

  try {
    const response = await this.request(
      `${this.cartRoot}cart/update.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          discount: [...codes.values()].join(','),
          sections,
          sections_url: `${this.cartRoot}cart`
        })
      }
    );

    if (!response.ok) {
      throw new Error('Discount update failed.');
    }

    const nextCart = await response.json();

    if (!Array.isArray(nextCart.items)) {
      throw new Error('Invalid cart response.');
    }

    updated = nextCart;

    const applied = this.getCartDiscountCodes(updated, true);

    if (!applied.some(value =>
      value.toLowerCase() === code.toLowerCase()
    )) {
      notice = `Added to your cart, but ${code} could not be confirmed. Check the discount before checkout.`;
    }
  } catch (error) {
    notice = `Added to your cart, but ${code} could not be confirmed. Check the discount before checkout.`;

    // Read the cart again without repeating either mutation.
    try {
      const response = await this.request(
        `${this.cartRoot}cart.js`,
        { cache: 'no-store' }
      );

      if (response.ok) {
        const latest = await response.json();

        if (Array.isArray(latest.items)) {
          updated = latest;
        }
      }
    } catch (refreshError) {
      // Keep the last known cart and display the confirmation message.
    }
  }

  if (this.getCartDiscountCodes(updated, true).some(value =>
    value.toLowerCase() === code.toLowerCase()
  )) {
    notice = '';
  }

  // Use post-discount sections, or let the existing section fallback fetch them.
  return {
    cart: updated,
    sections: updated.sections || {},
    notice
  };
}

    async addToCart(form) {
      if (
        this.busy ||
        form.dataset.canBuy !== 'true' ||
        form.closest('[inert]')
      ) return;

      if (
        form === this.memberForm
          ? (this.memberInCart || this.membershipChecking)
          : this.fastAdded
      ) return;

      this.cartRevision++;
      this.queued = null;

      if (this.desktop.matches) {
        this.selected = form.closest('[data-panel]').dataset.panel;
        this.renderSelection();
      }

      this.setBusy(true, form);
      this.message('');

      let added = false;
      let rejected = false;
      const root = this.cartRoot;

      const emit = (name, detail) => {
        document.documentElement.dispatchEvent(
          new CustomEvent(name, { bubbles: true, detail })
        );
      };

      emit('theme:loading:start');

      try {
        // Preserve Prestige's bundled-section and cart-event flow.
        const requested = [];

        emit('cart:prepare-bundled-sections', {
          sections: requested
        });

        const sections = [...new Set(requested)];
        const payload = new FormData(form);

        payload.set('sections', sections.join(','));
        payload.set(
          'sections_url',
          `${root}variants/${payload.get('id')}`
        );

        const response = await this.request(`${root}cart/add.js`, {
          method: 'POST',
          body: payload,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        added = response.ok;
        rejected = !response.ok;

        if (added) {
          this.cartRevision++;

          if (form === this.memberForm) {
            this.memberInCart = true;
          }
        }

        const result = await response.json();

        if (!response.ok) {
          const description =
            typeof result.description === 'string'
              ? result.description
              : 'This item could not be added. Please check its availability.';

          form.dispatchEvent(
            new CustomEvent('cart:error', {
              bubbles: true,
              detail: { error: description }
            })
          );

          throw new Error(description);
        }

        const cartResponse = await this.request(`${root}cart.js`);

        if (!cartResponse.ok) {
          throw new Error('Cart refresh failed.');
        }

        const offer = await this.applyOfferDiscount(
  form,
  await cartResponse.json(),
  sections
);

const cart = offer.cart;

this.updateFromCart(cart);
cart.sections = offer.sections ?? result.sections ?? {};

        // Retry section rendering if needed, never the purchase request.
        for (const id of sections) {
          if (
            typeof cart.sections[id] !== 'string' ||
            !cart.sections[id].trim()
          ) {
            const sectionResponse = await this.request(
              `${root}?section_id=${encodeURIComponent(id)}`
            );

            if (!sectionResponse.ok) {
              throw new Error('Cart section refresh failed.');
            }

            cart.sections[id] = await sectionResponse.text();
          }

          if (!cart.sections[id].trim()) {
            throw new Error('Cart section was empty.');
          }
        }

        const detail = {
          items: Array.isArray(result.items) ? result.items : [result],
          cart,
          onSuccessDo: 'force_open_drawer'
        };

        form.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail
          })
        );

        emit('cart:change', {
          cart,
          baseEvent: 'variant:add',
          onSuccessDo: 'force_open_drawer'
        });

        this.message(
  offer.notice || 'Added to your cart.',
  Boolean(offer.notice),
  true
);
      } catch (error) {
        if (added) {
          this.message(
            'Added to your cart, but the cart display could not refresh. View your cart to continue.',
            true,
            true
          );
        } else if (rejected) {
          this.message(error.message, true);
        } else {
          this.message(
            'We couldn’t confirm the add. Check your cart before trying again.',
            true,
            true
          );
        }
      } finally {
        emit('theme:loading:end');

        if (added && this.isConnected) {
          this.showAddedState(form);
        }

        this.setBusy(false);

        if (!added && this.isConnected) {
          this.queueCartRead();
        }
      }
    }
  }

  customElements.define('lgnd-offer-switcher', LGNDOfferSwitcher);
})();

/*
 * ============================================================================
 * 7. LGND+ MEMBERS BONUS STRIP
 * ============================================================================
 *
 * Powers the "Join LGND+" button in the homepage Members Bonus strip.
 *
 * - LGND+ not in cart: adds it (4-week selling plan) and opens the cart drawer.
 * - LGND+ already in cart: just opens the cart drawer.
 *
 * Uses the same Prestige cart events as the offer switcher, so the switcher's
 * LGND+ card updates to "Added to Cart" when the strip adds it (and the strip
 * updates when the switcher adds it).
 *
 * Safe to leave in place after the strip is removed: nothing runs unless
 * [data-lmb-strip] is on the page.
 */
(function () {
  'use strict';

  const STRIP_SELECTOR = '[data-lmb-strip]';

  function emit(name, detail) {
    document.documentElement.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail })
    );
  }

  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);

    try {
      return await fetch(url, { ...options, signal: controller.signal });
    } finally {
      clearTimeout(timer);
    }
  }

  function openCartDrawer(root) {
    const drawer = document.querySelector('cart-drawer, #cart-drawer');

    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
      return;
    }

    const toggle = document.querySelector('[aria-controls="cart-drawer"]');

    if (toggle) {
      toggle.click();
      return;
    }

    window.location.href = `${root}cart`;
  }

  function initStrip(strip) {
    if (strip.dataset.lmbReady === 'true') return;
    strip.dataset.lmbReady = 'true';

    // Logged-in members see no button, so there is nothing to wire up.
    const form = strip.querySelector('[data-lmb-form]');
    if (!form) return;

    const button = form.querySelector('[type="submit"]');
    const label = form.querySelector('[data-lmb-label]');
    const status = strip.querySelector('[data-lmb-status]');
    const variantId = String(form.querySelector('[name="id"]').value);
    const idleText = label.textContent.trim();
    const canBuy = form.dataset.canBuy === 'true';

    const root = (
      window.Shopify?.routes?.root ||
      strip.dataset.root ||
      '/'
    ).replace(/\/?$/, '/');

    let busy = false;
    let inCart = false;
    let revision = 0;
    let readTimer = null;

    function render() {
      button.disabled = busy || (!canBuy && !inCart);
      button.setAttribute('aria-busy', String(busy));
      strip.dataset.inCart = String(inCart);

      label.textContent = '';

      if (busy) {
        const spinner = document.createElement('span');
        spinner.className = 'lmb__spinner';
        spinner.setAttribute('aria-hidden', 'true');
        label.append(spinner, document.createTextNode('Adding'));
        return;
      }

      label.textContent = inCart
        ? 'In Your Cart'
        : canBuy
          ? idleText
          : 'Unavailable';
    }

    function message(text, error = false, showCart = false) {
      if (!status) return;

      status.textContent = text;
      strip.dataset.error = String(error);

      if (showCart && text) {
        const link = document.createElement('a');
        link.href = `${root}cart`;
        link.textContent = 'View your cart';
        status.append(' ', link);
      }
    }

    function updateFromCart(cart) {
      if (!Array.isArray(cart?.items)) return;

      inCart = cart.items.some(item => {
        return (
          String(item.variant_id ?? item.id) === variantId &&
          Number(item.quantity ?? 1) > 0
        );
      });

      render();
    }

    async function readCart() {
      const current = ++revision;

      try {
        const response = await request(`${root}cart.js`, { cache: 'no-store' });
        if (!response.ok) return;

        const cart = await response.json();

        if (current === revision) updateFromCart(cart);
      } catch (error) {
        // Keep the last known state if the cart can't be read.
      }
    }

    function queueRead() {
      clearTimeout(readTimer);
      readTimer = setTimeout(readCart, 100);
    }

    // Stay in sync with every cart change on the page (drawer, switcher, etc).
    ['cart:change', 'variant:add', 'line-item:change'].forEach(name => {
      document.addEventListener(name, event => {
        if (busy) return;

        if (Array.isArray(event.detail?.cart?.items)) {
          revision++;
          updateFromCart(event.detail.cart);
        } else {
          queueRead();
        }
      });
    });

    ['cart:refresh', 'cart-drawer:refreshed'].forEach(name => {
      document.addEventListener(name, queueRead);
    });

    window.addEventListener('pageshow', queueRead);

    form.addEventListener('submit', async event => {
      event.preventDefault();

      if (busy) return;

      if (inCart) {
        openCartDrawer(root);
        return;
      }

      if (!canBuy) return;

      busy = true;
      revision++;
      render();
      message('');

      let added = false;
      let rejected = false;

      emit('theme:loading:start');

      try {
        // Re-check the cart first so a second membership is never added
        // (another tab, or a click before the first cart read finished).
        const check = await request(`${root}cart.js`, { cache: 'no-store' });

        if (check.ok) {
          const current = await check.json();

          if (Array.isArray(current.items)) {
            inCart = current.items.some(item => {
              return String(item.variant_id ?? item.id) === variantId;
            });

            if (inCart) {
              openCartDrawer(root);
              return;
            }
          }
        }

        // Ask Prestige which cart sections need re-rendering.
        const requested = [];
        emit('cart:prepare-bundled-sections', { sections: requested });

        const sections = [...new Set(requested)];
        const payload = new FormData(form);

        payload.set('sections', sections.join(','));
        payload.set('sections_url', `${root}variants/${payload.get('id')}`);

        const response = await request(`${root}cart/add.js`, {
          method: 'POST',
          body: payload,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        added = response.ok;
        rejected = !response.ok;

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            typeof result.description === 'string'
              ? result.description
              : 'LGND+ could not be added. Please try again.'
          );
        }

        inCart = true;

        const cartResponse = await request(`${root}cart.js`, { cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('Cart refresh failed.');

        const cart = await cartResponse.json();
        cart.sections = result.sections || {};

        // Retry section rendering if needed, never the add itself.
        for (const id of sections) {
          if (
            typeof cart.sections[id] !== 'string' ||
            !cart.sections[id].trim()
          ) {
            const sectionResponse = await request(
              `${root}?section_id=${encodeURIComponent(id)}`
            );

            if (!sectionResponse.ok) {
              throw new Error('Cart section refresh failed.');
            }

            cart.sections[id] = await sectionResponse.text();
          }
        }

        updateFromCart(cart);

        const detail = {
          items: Array.isArray(result.items) ? result.items : [result],
          cart,
          onSuccessDo: 'force_open_drawer'
        };

        form.dispatchEvent(
          new CustomEvent('variant:add', { bubbles: true, detail })
        );

        emit('cart:change', {
          cart,
          baseEvent: 'variant:add',
          onSuccessDo: 'force_open_drawer'
        });
      } catch (error) {
        if (added) {
          message('LGND+ was added, but the cart could not refresh.', true, true);
        } else if (rejected) {
          message(error.message, true);
        } else {
          message('We couldn’t confirm the add. Check your cart before trying again.', true, true);
        }
      } finally {
        emit('theme:loading:end');
        busy = false;
        render();

        if (!added) queueRead();
      }
    });

    render();
    readCart();
  }

  function start() {
    document.querySelectorAll(STRIP_SELECTOR).forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();


/*
 * ============================================================================
 * 8. LGND+ MEMBERS BONUS COUNTDOWN
 * ============================================================================
 *
 * Turns any element with [data-lmb-countdown] into a live countdown to its
 * data-ends time (ISO with offset, e.g. 2026-10-11T23:59:59-04:00).
 *
 *   More than 24 hours left:  ENDS IN 2 DAYS 5 HOURS!
 *   24 hours or less:         ENDS IN 5 HRS 12 MINS!
 *   Final hour:               ENDS IN 42 MINUTES!
 *   After the end:            ENDED
 *
 * Before data-starts, the element keeps its original text (MEMBERS BONUS).
 * Zero parts are dropped ("ENDS IN 2 DAYS!" rather than "2 DAYS 0 HOURS").
 * Safe if no countdown is on the page: nothing runs.
 */
(function () {
  'use strict';

  const SELECTOR = '[data-lmb-countdown]';
  const MINUTE = 60 * 1000;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  const unit = (value, one, many) => `${value} ${value === 1 ? one : many}`;

  function join(first, second) {
    return second ? `${first} ${second}` : first;
  }

  function countdownText(remaining) {
    // More than 24 hours: days + hours.
    if (remaining > DAY) {
      const days = Math.floor(remaining / DAY);
      const hours = Math.floor((remaining % DAY) / HOUR);

      return `ENDS IN ${join(
        unit(days, 'DAY', 'DAYS'),
        hours ? unit(hours, 'HOUR', 'HOURS') : ''
      )}!`;
    }

    // 24 hours or less: hours + minutes.
    if (remaining > HOUR) {
      const hours = Math.floor(remaining / HOUR);
      const minutes = Math.floor((remaining % HOUR) / MINUTE);

      return `ENDS IN ${join(
        unit(hours, 'HR', 'HRS'),
        minutes ? unit(minutes, 'MIN', 'MINS') : ''
      )}!`;
    }

    // Final hour: minutes only (rounded up, so it never shows 0).
    const minutes = Math.max(1, Math.ceil(remaining / MINUTE));

    return `ENDS IN ${unit(minutes, 'MINUTE', 'MINUTES')}!`;
  }

  const items = new Set();
  let timer = null;

  function tick() {
    const now = Date.now();

    items.forEach(element => {
      if (!element.isConnected) {
        items.delete(element);
        return;
      }

      const start = Date.parse(element.dataset.starts || '') || 0;
      const end = Date.parse(element.dataset.ends || '');

      if (!end) return;

      let text;
      let state;

      if (now < start) {
        text = element.dataset.idleText;
        state = 'upcoming';
      } else if (now >= end) {
        text = element.dataset.endedText || 'ENDED';
        state = 'ended';
      } else {
        text = countdownText(end - now);
        state = 'live';
      }

      if (element.textContent !== text) element.textContent = text;
      if (element.dataset.state !== state) element.dataset.state = state;
    });

    if (!items.size) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    document.querySelectorAll(SELECTOR).forEach(element => {
      if (!element.dataset.idleText) {
        element.dataset.idleText = element.textContent.trim();
      }

      items.add(element);
    });

    if (!items.size) return;

    tick();

    if (!timer) timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);

  // Catch up immediately when a backgrounded tab becomes visible again.
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && items.size) tick();
  });
})();


/*
 * ============================================================================
 * 9. LGND+ MEMBERS BONUS REVEAL (A/B VARIANT B)
 * ============================================================================
 *
 * For strips marked [data-lmb-reveal]:
 *
 *   Desktop (1024px+, no toggle): always open.
 *   Below 1024px, follows the offer switcher toggle:
 *     LGND+ selected     -> data-revealed="true"  (CSS slides the strip open)
 *     Fast Pass selected -> data-revealed="false" (CSS slides it closed)
 *
 * The switcher's own data-selected attribute is the source of truth, so this
 * also follows its auto-switch back to Fast Pass after LGND+ is added.
 *
 * Collapsed strips are inert, so their buttons can't be tabbed to.
 * Fires a bubbling "lmb:revealed" event each time a strip opens from a
 * toggle tap (not on desktop page load), for A/B tracking.
 *
 * Does nothing on pages without a [data-lmb-reveal] strip, so the live
 * homepage (variant A) is unaffected.
 */
(function () {
  'use strict';

  const SELECTOR = '[data-lmb-reveal]';
  const desktop = matchMedia('(min-width: 1024px)');
  const observed = new WeakSet();
  const doneTimers = new WeakMap();

  function setOpen(strip, open) {
    const wasOpen = strip.dataset.revealed === 'true';
    if (open === wasOpen && strip.dataset.revealed) return;

    strip.dataset.revealed = String(open);

    const panel = strip.querySelector('.lmb__reveal');
    if (panel) panel.inert = !open;

    clearTimeout(doneTimers.get(strip));

    if (open) {
      // Let the glasses cutouts overflow only after the slide finishes.
      doneTimers.set(strip, setTimeout(() => {
        strip.dataset.revealDone = 'true';
      }, 500));

      if (!wasOpen && !desktop.matches) {
        strip.dispatchEvent(new CustomEvent('lmb:revealed', { bubbles: true }));
      }
    } else {
      strip.dataset.revealDone = 'false';
    }
  }

  function plusSelected() {
    return [...document.querySelectorAll('lgnd-offer-switcher')].some(
      switcher => switcher.dataset.selected === 'plus'
    );
  }

  function sync() {
    const open = desktop.matches || plusSelected();
    document.querySelectorAll(SELECTOR).forEach(strip => setOpen(strip, open));
  }

  const observer = new MutationObserver(sync);

  desktop.addEventListener('change', () => {
    if (document.querySelector(SELECTOR)) sync();
  });

  function start() {
    if (!document.querySelector(SELECTOR)) return;

    document.querySelectorAll('lgnd-offer-switcher').forEach(switcher => {
      if (observed.has(switcher)) return;

      observed.add(switcher);
      observer.observe(switcher, {
        attributes: true,
        attributeFilter: ['data-selected']
      });
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();